<nav class="ed-nav e--g-theme-dark">
  <div class="container">
    <div class="ed-inner">
      <a class="main-logo" target="_blank" [href]="context.links.promo_index|userToken">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4657 687">
          <path class="ed-surface"
                d="M1390.64,467v26.57H1185.16V203h199.25v26.57H1215.87V332.89h116.58V359H1215.87V467Zm72.22-264h30.72V467H1656.3v26.57H1462.86Zm244.5,0h30.71V493.54h-30.71Zm181.81,26.57H1787.05V203h235v26.57H1919.89v264h-30.72ZM2276.46,467v26.57H2071V203h199.26v26.57H2101.7V332.89h116.58V359H2101.7V467Zm386-118.72c0-85.93,66.42-149.44,156.5-149.44s156.5,63.1,156.5,149.44S2909.08,497.69,2819,497.69,2662.5,434.18,2662.5,348.25Zm258.62,0c0-59.36-43.59-102.12-102.12-102.12s-102.12,42.76-102.12,102.12S2760.47,450.37,2819,450.37,2921.12,407.61,2921.12,348.25Zm362,145.29-.42-192.61-95.47,159.4h-24.08l-95.48-156.91V493.54h-51.47V203h44.42L3176,395.57,3289.32,203h44.42l.41,290.58ZM3723.51,203h54V493.54h-54Zm390.62,0V493.54h-44.42L3909.48,296.78V493.54h-53.55V203h44.42l160.23,196.76V203Zm53.54,259.86,18.68-41.93c23.25,18.69,60.19,32,95.9,32,45.24,0,64.34-16.19,64.34-37.78,0-62.68-172.69-21.58-172.69-129.51,0-46.91,37.36-86.76,117.06-86.76,34.87,0,71.4,9.13,96.72,25.73l-17,41.93c-26.15-15.36-54.79-22.83-80.11-22.83-44.83,0-63.1,17.44-63.1,39.44,0,61.85,172.27,21.58,172.27,128.27,0,46.49-37.77,86.34-117.47,86.34C4237,497.69,4191.75,483.58,4167.67,462.82ZM3555.4,203h-53.14L3371.5,493.54h55.63l10-23.53H3437l4.26-9.65,14.51-34.08L3474,384l54.38-127,42.84,99.3h.21L3581.53,380l1.68,3.91h0l18.09,42.82,28.85,66.77h56.46Zm-1088,0h-127v217.9h54V248.62h70.57c64.76,0,106.68,39.44,106.68,99.63s-41.92,99.63-106.68,99.63H2421.1v45.66h46.31c94.23,0,158.57-58.11,158.57-145.29S2561.64,203,2467.41,203Z"></path>
          <path class="ed-surface"
                d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"></path>
        </svg>
      </a>
    </div>
  </div>
</nav>

<div class="ed-domain-catch-head">
  <div class="container">

    <div class="ed-box">
      <app-icon>celebration</app-icon>
      <h1 i18n>
        Erfolgreich gecatcht<br>
        mit ELITEDOMAINS
      </h1>
      <p i18n>Diese Domain wurde mit unserem <a target="_blank" [href]="context.links.app_catcher|userToken">Domain Catcher</a> registriert.</p>
    </div>

    <div class="ed-foot">
      <h2 i18n>Bist du der neue Inhaber?</h2>
      <p i18n>Als neuer Inhaber kannst du das Routing über den Redirector im Domain Bestand anpassen.</p>
    </div>

    <div class="ed-foot">
      <h2 i18n>Warst du der alte Inhaber?</h2>
      <p i18n>Du hast deine alte Domain verloren, sie wurde nach einer Karenzzeit von 30 Tagen bei der DENIC gelöscht. Wir als Provider haben diese Domain für einen Kunden im Moment des Wieder-Frei-Werdens regulär registriert. Etwaige Schadensersatzansprüche sind an den alten Provider zu stellen.</p>
    </div>

  </div>
</div>

<div class="ed-domain-catch-body">
  <div class="container">
    <div class="e-start-now">
      <h2 i18n>Teste uns als Catcher und Provider</h2>
      <p i18n>
        Falls du Domains catchst, <a target="_blank" [href]="context.links.app_catcher|userToken">trag jetzt deine Droplist bei uns ein</a>! Du verlierst nichts und erhöhst nur deine Chancen, deine Wunschdomains zu bekommen.
        <br><br>
        Und als Provider werden wir dich nicht enttäuschen: Domains catchen, günstig registrieren, smart verwalten und easy verkaufen.
      </p>
      <a [href]="context.links.register|userToken" edButton i18n>Jetzt kostenlos registrieren</a>
    </div>

    <br><br><br>
    <h2 i18n>Wir sind der vielleicht beste Provider der Welt</h2>
    <div class="grid">
      <div class="cell m4">
        <div class="e-feature">
          <h3 class="e-feature-head" i18n>Domains verwalten</h3>
          <p i18n>
            Günstige <a [href]="context.links.promo_index|userToken" target="_blank">.de Domains registrieren</a> und smart verwalten. Beste Preise ab der 1. Domain beim Portfolio Umzug. Mit vielen extra <a [href]="context.links.marketplace" target="_blank">Funktionen</a>.
          </p>
        </div>
      </div>
      <div class="cell m4">
        <div class="e-feature">
          <h3 class="e-feature-head" i18n>Domains verkaufen</h3>
          <p i18n>
            Einfach und automatisiert <a [href]="context.links.promo_sell_domains|userToken" target="_blank">Domains verkaufen</a>: per Festpreis, Preisvorschlag oder kostenlosem Formular. Mit eigenem <a [href]="context.links.marketplace" target="_blank">Domain Marktplatz</a>.
          </p>
        </div>
      </div>
      <div class="cell m4">
        <div class="e-feature">
          <h3 class="e-feature-head" i18n>Domains catchen</h3>
          <p i18n>
            Mit dem <a [href]="context.links.promo_catcher|userToken" target="_blank">Domain Catcher</a> gelöschte Domains automatisch neu registrieren. Höhere Gebote erhalten mehr Ressourcen für mehr Versuche.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="ed-paynow-page e--g-theme-dark">
  <div class="container">
    <div class="ed-inner">
      <div class="ed-note">
        <a class="main-logo" [href]="context.links.promo_index|userToken">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4657 687">
            <path class="ed-surface"
                  d="M1390.64,467v26.57H1185.16V203h199.25v26.57H1215.87V332.89h116.58V359H1215.87V467Zm72.22-264h30.72V467H1656.3v26.57H1462.86Zm244.5,0h30.71V493.54h-30.71Zm181.81,26.57H1787.05V203h235v26.57H1919.89v264h-30.72ZM2276.46,467v26.57H2071V203h199.26v26.57H2101.7V332.89h116.58V359H2101.7V467Zm386-118.72c0-85.93,66.42-149.44,156.5-149.44s156.5,63.1,156.5,149.44S2909.08,497.69,2819,497.69,2662.5,434.18,2662.5,348.25Zm258.62,0c0-59.36-43.59-102.12-102.12-102.12s-102.12,42.76-102.12,102.12S2760.47,450.37,2819,450.37,2921.12,407.61,2921.12,348.25Zm362,145.29-.42-192.61-95.47,159.4h-24.08l-95.48-156.91V493.54h-51.47V203h44.42L3176,395.57,3289.32,203h44.42l.41,290.58ZM3723.51,203h54V493.54h-54Zm390.62,0V493.54h-44.42L3909.48,296.78V493.54h-53.55V203h44.42l160.23,196.76V203Zm53.54,259.86,18.68-41.93c23.25,18.69,60.19,32,95.9,32,45.24,0,64.34-16.19,64.34-37.78,0-62.68-172.69-21.58-172.69-129.51,0-46.91,37.36-86.76,117.06-86.76,34.87,0,71.4,9.13,96.72,25.73l-17,41.93c-26.15-15.36-54.79-22.83-80.11-22.83-44.83,0-63.1,17.44-63.1,39.44,0,61.85,172.27,21.58,172.27,128.27,0,46.49-37.77,86.34-117.47,86.34C4237,497.69,4191.75,483.58,4167.67,462.82ZM3555.4,203h-53.14L3371.5,493.54h55.63l10-23.53H3437l4.26-9.65,14.51-34.08L3474,384l54.38-127,42.84,99.3h.21L3581.53,380l1.68,3.91h0l18.09,42.82,28.85,66.77h56.46Zm-1088,0h-127v217.9h54V248.62h70.57c64.76,0,106.68,39.44,106.68,99.63s-41.92,99.63-106.68,99.63H2421.1v45.66h46.31c94.23,0,158.57-58.11,158.57-145.29S2561.64,203,2467.41,203Z"></path>
            <path class="ed-surface"
                  d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"></path>
          </svg>
        </a>

        <ng-container i18n>
          Der vielleicht beste Provider der Welt mit Catcher und Marktplatz.
        </ng-container>
      </div>

      <div class="ed-links">
        <a [routerLink]="['/impressum']" rel="nofollow" class="ed-imprint" target="_blank" i18n>
          Impressum
        </a>
        <br>
        <app-i18n-selector/>
      </div>
    </div>
  </div>
</footer>
